import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import Coupon from './coupon/Coupon.jsx';
import BetHistory from './bet-history/BetHistory.jsx';
import CouponDropDownMenu from './CouponDropDownMenu.jsx';
import UnauthUserCouponDropDownMenu from './UnauthUserCouponDropDownMenu.jsx';

import {toggleOneClickMode as toggleOneClickModeAction,
    setAcceptFactorChangeMode as setAcceptFactorChangeModeAction} from 'actions/creators/BettingMode';

import * as AcceptFactorChangeMode from 'constants/AcceptFactorChange';
import PerfectScrollbar from "react-perfect-scrollbar";

const messages = defineMessages({
    title: {
        id: 'betpanel.title',
        defaultMessage: 'Ставки'
    },
    help: {
        id: 'betpanel.help',
        defaultMessage: 'Кликните на любой исход, чтобы добавить ставку в купон.'
    }
});

class BetPanel extends React.Component {
    static propTypes = {
        bettingMode: React.PropTypes.object.isRequired,
        languageId: React.PropTypes.number.isRequired,
        user: React.PropTypes.any,
        hasNoBetSlips: React.PropTypes.bool.isRequired,
        toggleOneClickModeAction: React.PropTypes.func.isRequired,
        setAcceptFactorChangeModeAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onOneClickBetClick = this._onOneClickBetClick.bind(this);
        this._onAcceptChangeClick = this._onAcceptChangeClick.bind(this);
        this._onPopupClosing = this._onPopupClosing.bind(this);
        this._onShowMenuClick = this._onShowMenuClick.bind(this);

        this.state = {
            popupShown: false
        };
    }

    _onOneClickBetClick(e) {
        e.preventDefault();

        if (this.props.user) {
            this.props.toggleOneClickModeAction();
        }
    }

    _onPopupClosing() {
        this.setState({
            popupShown: false
        });
    }

    _onShowMenuClick(e) {
        e.preventDefault();

        this.setState({
            popupShown: true
        });
    }

    static getNextAcceptFactorChangeMode(current) {
        let newMode = AcceptFactorChangeMode.NONE;
        if (current === AcceptFactorChangeMode.NONE) {
            newMode = AcceptFactorChangeMode.DECREASE;
        } else if (current === AcceptFactorChangeMode.DECREASE) {
            newMode = AcceptFactorChangeMode.INCREASE;
        } else if (current === AcceptFactorChangeMode.INCREASE) {
            newMode = AcceptFactorChangeMode.BOTH;
        }

        return newMode;
    }

    static renderHelpMessage() {
        return (
            <div className="history-menu cf">
                <div className="body history-menu-body">
                    <div className="unauth-user-panel">
                        <p>&nbsp;</p>
                        <p>
                            <FormattedMessage {...messages.help}/>
                        </p>
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
        );
    }

    _onAcceptChangeClick(e) {
        e.preventDefault();

        if (!this.props.user) {
            return;
        }

        const bettingMode = this.props.bettingMode;

        const acceptFactorChangeMode = bettingMode.get('acceptFactorChange');

        const newMode = BetPanel.getNextAcceptFactorChangeMode(acceptFactorChangeMode);

        this.props.setAcceptFactorChangeModeAction(newMode);
    }

    onScrollUpdate = () => {
        this.refs._scrollBarRef2.updateScroll();
    };

    render() {
        const {bettingMode, user, hasNoBetSlips} = this.props;
        const showPopup = this.state.popupShown;

        const isOneClick = bettingMode.get('isOneClick');

        let oneClickCls = 'quick-bet';
        if (isOneClick) {
            oneClickCls += ' enabled';
        }

        const acceptFactorChangeMode = bettingMode.get('acceptFactorChange');

        let acceptChangeCls = 'accept-change-button';
        if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
            acceptChangeCls += ' accept-low-high';
        } else if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
            acceptChangeCls += ' accept-high';
        } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
            acceptChangeCls += ' accept-low';
        } else {
            acceptChangeCls += ' accept-change';
        }

        const props = {
            bettingMode,
            user,
            onClosing: this._onPopupClosing
        };

        return (
            <div>
                <div className="heading coupon-heading top-coupon-heading">
                    <div className="title">
                        <div className="dropdown--menu__container">
                            <a href="#" className="dropdown--toggle" onClick={this._onShowMenuClick}/>
                            {(user && showPopup) && <CouponDropDownMenu {...props}/>}
                            {(!user && showPopup) && <UnauthUserCouponDropDownMenu onClosing={this._onPopupClosing} />}
                        </div>
                        <FormattedMessage {...messages.title}>
                            {(label) => <label onClick={this._onShowMenuClick}>{label}</label>}
                        </FormattedMessage>
                    </div>
                    <div className="controls">
                        {user && <a href="#" className={acceptChangeCls} onClick={this._onAcceptChangeClick}/>}
                        {user && <a href="#" className={oneClickCls} onClick={this._onOneClickBetClick}/>}
                        {!user && <a href="#" className={acceptChangeCls} style={{cursor:'default'}} />}
                        {!user && <a href="#" className={oneClickCls} style={{cursor:'default'}} />}
                    </div>
                </div>
                <div id="coupons" className="coupon">
                    <div className="scroll--wrapper" ref="couponContainer">
                        <PerfectScrollbar ref='_scrollBarRef2'>
                            <div className="scroll--wrapper__inner">
                                {hasNoBetSlips && BetPanel.renderHelpMessage()}
                                <Coupon onUpdateSize={this.onScrollUpdate}/>
                                {user && <BetHistory/>}
                            </div>
                        </PerfectScrollbar>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const bettingMode = state.application.get('bettingMode');
    const languageId = state.application.get('languageId');
    const user = state.auth.get('user');
    const betSlips = state.application.getIn(['coupon', 'betSlips']);
    const hasNoBetSlips = betSlips === undefined || betSlips.size === 0;

    return {
        bettingMode,
        languageId,
        user,
        hasNoBetSlips
    };
}

export default connect(select, {
    toggleOneClickModeAction, setAcceptFactorChangeModeAction
})(BetPanel);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/BetPanel.jsx